import React from "react";
import { TooltipIcon } from "../../../../assets/js/image";

const TitleName = (props) => {
  return (
    <div className="col-md-12 mt-2">
      <div className="border-b col-md-12">
        <label className="vobSectionTitle">{props.title}</label>
        {!props.hideTooltip && (
          <TooltipIcon style="m-bottom-5"></TooltipIcon>
        )}
      </div>
    </div>
  );
};

export default TitleName;
